import React, { useContext, useEffect, useMemo, useState } from 'react'
import { HolderOutlined } from '@ant-design/icons'
import type { DragEndEvent } from '@dnd-kit/core'
import { DndContext } from '@dnd-kit/core'
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Button, Table, Row, Col } from 'antd'
import type { TableColumnsType } from 'antd'

export interface DataType {
  key: string
  name: string
  disabled?: boolean
  check?: boolean
}

interface RowContextProps {
  setActivatorNodeRef?: (element: HTMLElement | null) => void
  listeners?: SyntheticListenerMap
}

interface Props {
  onHandleChange?: (item: React.Key[]) => void
  data: DataType[]
  fixedItems?: string[]
  onSave: (param: any) => void
  tableType?: string
  positionFixed?: string
}

const RowContext = React.createContext<RowContextProps>({})

const DragHandle = (props: { fix: boolean }) => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext)
  const [color, setColor] = useState<string>('transparent')
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{
        cursor: props.fix ? 'not-allowed' : 'move',
        border: 'none',
        backgroundColor: color,
      }}
      ref={setActivatorNodeRef}
      disabled={props.fix}
      onFocus={() => setColor('#3239b1')}
      onBlur={() => setColor('transparent')}
      {...listeners}
    />
  )
}

interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string
}

const TableRow: React.FC<RowProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props['data-row-key'] })

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  }

  const contextValue = useMemo<RowContextProps>(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners],
  )

  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  )
}

const FilterList: React.FC<Props> = (props: Props) => {
  const { data, fixedItems, onSave, tableType, positionFixed, onHandleChange } =
    props
  const [dataSource, setDataSource] = React.useState<DataType[]>(data)

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (
      active.id !== positionFixed &&
      over?.id !== positionFixed &&
      active.id !== over?.id
    ) {
      setDataSource((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id,
        )
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id,
        )
        return arrayMove(prevState, activeIndex, overIndex)
      })
    }
  }

  const columns: TableColumnsType<DataType> = [
    { title: '字段名', dataIndex: 'name', key: 'name' },
    {
      key: 'sort',
      align: 'center',
      width: 80,
      title: '排序',
      render: (text, record) => (
        <DragHandle fix={positionFixed === record.key} />
      ),
    },
  ]

  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])

  useEffect(() => {
    setSelectedRowKeys(
      data.filter((item) => item.check).map((item) => item.key),
    )
    setDataSource(data)
  }, [data, tableType])

  const saveData = () => {
    onSave(
      dataSource.map((item) => {
        return {
          key: item.key,
          check: selectedRowKeys.includes(item.key),
        }
      }),
    )
  }

  return (
    <div>
      <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext
          items={dataSource.map((i) => i.key)}
          strategy={verticalListSortingStrategy}
        >
          <Table
            rowKey="key"
            components={{ body: { row: TableRow } }}
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
              selectedRowKeys: selectedRowKeys,
              onChange: (selectedRowKeys: React.Key[]) => {
                setSelectedRowKeys(selectedRowKeys as string[])
                onHandleChange?.(selectedRowKeys as string[])
              },
              getCheckboxProps: (record: DataType) => ({
                disabled: fixedItems?.includes(record.key),
                name: record.name,
              }),
            }}
            pagination={false}
            scroll={{ y: 400 }}
            size="small"
          />
        </SortableContext>
      </DndContext>
      <Row>
        <Col span={24} style={{ textAlign: 'center', margin: '10px 0px' }}>
          <Button
            type="primary"
            style={{ width: '100px' }}
            size="middle"
            onClick={saveData}
          >
            保存
          </Button>
        </Col>
      </Row>
    </div>
  )
}

export default FilterList
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { HolderOutlined } from '@ant-design/icons'
import type { DragEndEvent } from '@dnd-kit/core'
import { DndContext } from '@dnd-kit/core'
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Button, Table, Row, Col } from 'antd'
import type { TableColumnsType } from 'antd'

export interface DataType {
  key: string
  name: string
  disabled?: boolean
  check?: boolean
}

interface RowContextProps {
  setActivatorNodeRef?: (element: HTMLElement | null) => void
  listeners?: SyntheticListenerMap
}

interface Props {
  onHandleChange?: (item: React.Key[]) => void
  data: DataType[]
  fixedItems?: string[]
  onSave: (param: any) => void
  tableType?: string
  positionFixed?: string
}

const RowContext = React.createContext<RowContextProps>({})

const DragHandle = (props: { fix: boolean }) => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext)
  const [color, setColor] = useState<string>('transparent')
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{
        cursor: props.fix ? 'not-allowed' : 'move',
        border: 'none',
        backgroundColor: color,
      }}
      ref={setActivatorNodeRef}
      disabled={props.fix}
      onFocus={() => setColor('#3239b1')}
      onBlur={() => setColor('transparent')}
      {...listeners}
    />
  )
}

interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string
}

const TableRow: React.FC<RowProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props['data-row-key'] })

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  }

  const contextValue = useMemo<RowContextProps>(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners],
  )

  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  )
}

const FilterList: React.FC<Props> = (props: Props) => {
  const { data, fixedItems, onSave, tableType, positionFixed, onHandleChange } =
    props
  const [dataSource, setDataSource] = React.useState<DataType[]>(data)

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (
      active.id !== positionFixed &&
      over?.id !== positionFixed &&
      active.id !== over?.id
    ) {
      setDataSource((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id,
        )
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id,
        )
        return arrayMove(prevState, activeIndex, overIndex)
      })
    }
  }

  const columns: TableColumnsType<DataType> = [
    { title: '字段名', dataIndex: 'name', key: 'name' },
    {
      key: 'sort',
      align: 'center',
      width: 80,
      title: '排序',
      render: (text, record) => (
        <DragHandle fix={positionFixed === record.key} />
      ),
    },
  ]

  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])

  useEffect(() => {
    setSelectedRowKeys(
      data.filter((item) => item.check).map((item) => item.key),
    )
    setDataSource(data)
  }, [data, tableType])

  const saveData = () => {
    onSave(
      dataSource.map((item) => {
        return {
          key: item.key,
          check: selectedRowKeys.includes(item.key),
        }
      }),
    )
  }

  return (
    <div>
      <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext
          items={dataSource.map((i) => i.key)}
          strategy={verticalListSortingStrategy}
        >
          <Table
            rowKey="key"
            components={{ body: { row: TableRow } }}
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
              selectedRowKeys: selectedRowKeys,
              onChange: (selectedRowKeys: React.Key[]) => {
                setSelectedRowKeys(selectedRowKeys as string[])
                onHandleChange?.(selectedRowKeys as string[])
              },
              getCheckboxProps: (record: DataType) => ({
                disabled: fixedItems?.includes(record.key),
                name: record.name,
              }),
            }}
            pagination={false}
            scroll={{ y: 400 }}
            size="small"
          />
        </SortableContext>
      </DndContext>
      <Row>
        <Col span={24} style={{ textAlign: 'center', margin: '10px 0px' }}>
          <Button
            type="primary"
            style={{ width: '100px' }}
            size="middle"
            onClick={saveData}
          >
            保存
          </Button>
        </Col>
      </Row>
    </div>
  )
}

export default FilterList
